export default {
  table: {
    replyType: "Reply Type",
    keyword: "Keyword",
    content: "Reply Content",
    readonly: "Read-only",
    isPrivate: "Private Reply",
    all: "All",
    private: "Private",
    public: "Public",
  },
};
